var _defs, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "da94dbb5ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 121.875 113 L 253.125 113 L 253.125 262 L 121.875 262 Z M 121.875 113 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da94dbb5ec)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e44d26",
    d: "M 133.789062 247.082031 L 121.835938 113.035156 L 253.164062 113.035156 L 241.199219 247.066406 L 187.417969 261.96875 Z M 133.789062 247.082031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f16529",
    d: "M 230.957031 238.527344 L 241.183594 123.996094 L 187.5 123.996094 L 187.5 250.578125 Z M 230.957031 238.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 187.445312 140.4375 L 146.273438 140.4375 L 150.707031 190.152344 L 187.5 190.152344 L 187.5 173.714844 L 165.746094 173.714844 L 164.242188 156.878906 L 187.5 156.878906 L 187.5 140.4375 Z M 187.5 216.355469 L 187.429688 216.375 L 169.121094 211.433594 L 167.957031 198.320312 L 151.445312 198.320312 L 153.746094 224.132812 L 187.425781 233.441406 L 187.5 233.417969 Z M 187.5 216.355469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 187.445312 190.152344 L 207.691406 190.152344 L 205.828125 211.46875 L 187.492188 216.417969 L 187.492188 233.519531 L 221.195312 224.179688 L 225.710938 173.703125 L 187.5 173.703125 Z M 228.234375 144.847656 L 228.625 140.4375 L 187.433594 140.4375 L 187.433594 156.875 L 227.144531 156.875 L 227.472656 153.179688 Z M 228.234375 144.847656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.1f985841504d9bd7fdba2b87928580a5.svg";
export { ForwardRef as ReactComponent };